import React, { useEffect, useState, useCallback } from "react";
import agent from "../../app/api/agent";
import useToaster from "../../app/hooks/useToaster";
import PaginationComponent from "../../components/pagination/Pagination";
import { Excursion } from "./types";
import { SORT_BY } from "../shadowingsFilter/sort_options";
import { ExcursionFilter } from "./useExcursionFilter";

const useExcursions = (filter: ExcursionFilter, sortBy: SORT_BY) => {
  const [excursions, setExcursions] = useState<Excursion[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState<number | undefined>(undefined);
  const [pageNumber, setPageNumber] = useState(1);
  const [isLoading, setLoading] = useState(true);
  const { apiError } = useToaster();

  const loadExcursions = useCallback(
    async (page: number) => {
      setLoading(true);

      try {
        const response = await agent.Excursions.list(filter, sortBy, page);
        setExcursions(response.items);
        setTotalPages(response.totalPages);
        setTotalCount(response.totalCount);
      } catch (error) {
        setExcursions([]);
        apiError(error);
      } finally {
        setLoading(false);
      }
    },
    [apiError, filter, sortBy]
  );

  useEffect(() => {
    setPageNumber(1);
    loadExcursions(1);
  }, [loadExcursions]);

  const handlePageChange = (page: number) => {
    setPageNumber(page);
    loadExcursions(page);
  };

  const renderPagination = () => (
    <PaginationComponent totalPages={totalPages} pageNumber={pageNumber} handlePageChange={handlePageChange} />
  );

  return {
    excursions,
    totalCount,
    isLoading,
    reload: () => loadExcursions(pageNumber),
    renderPagination,
  };
};

export default useExcursions;
